import Vue from 'vue'
import { message } from 'ant-design-vue'
import Axios from 'axios'
import { HTTP_CONFIG } from '../config'
import qs from 'qs'
import store from '../store'

class Http {
  constructor (options) {
    this.options = options
    this.queue = {}
  }

  destroy (url) {
    delete this.queue[url]
    if (!Object.keys(this.queue).length) {
      // Spin.hide()
    }
  }

  getConfig () {
    return Object.assign({}, this.options, {})
  }

  interceptors (instance) {
    const url = this.options.baseURL
    // request
    instance.interceptors.request.use(config => {
      this.queue[url] = true
      if (!config.url.includes('/login')) {
        config.headers.Token = Vue.ls.get('Token')
      }
      // 请求时缓存该请求，路由跳转时取消
      config.cancelToken = new Axios.CancelToken(function (cancel) {
        store.commit('system/PUSH_TOKEN', { cancelToken: cancel })
      })
      return config
    }, error => {
      return Promise.reject(error)
    })
    // response
    instance.interceptors.response.use(res => {
      this.destroy(url)
      const { status, data: { data, code, msg, succ } } = res
      if (status !== 200) {
        message.error('连接服务器失败!')
        return {}
      } else {
        // 如果接口返回session失效，重登
        if (code === 'SS0002') {
          setTimeout(() => {
            Vue.ls.clear()
            let redirect = location.href.split('/').filter((it, index) => index > 2).join('/')
            redirect = decodeURIComponent(`/${redirect}`)
            window.location.href = `/Login?redirect=${redirect}`
          }, 500)
        }
        if (code !== 'S00000') {
          message.destroy()
          message.error(msg)
          // const errorInfo = {
          //   statusText: msg,
          //   status: code,
          //   request: { responseURL: res.config.url }
          // }
          // addErrorLog(errorInfo)
        }
      }
      return {
        data,
        succ,
        code,
        msg
      }
    }, error => {
      this.destroy(url)
      const errorInfo = error.response
      let config, statusText, status
      if (!errorInfo) {
        const errObj = JSON.parse(JSON.stringify(error))
        try {
          config = errObj.config
          statusText = errObj.request.statusText
          status = errObj.request.status
        } catch (e) {
          config = errObj.config
          statusText = errObj.message
          status = 404
        }
        // errorInfo = {
        //   statusText,
        //   status,
        //   request: { responseURL: config.url }
        // }
        /*eslint-disable*/
        console.info(`${status} ===> ${statusText}`)
      }
      if (config) {
        message.error('连接服务器发生异常，请检查网络是否正常!')
      }
      // addErrorLog(errorInfo)
      return Promise.reject(error)
    })
  }

  request (options) {
    const instance = Axios.create()
    options = Object.assign(this.getConfig(), options)
    options = this.isGet(options)
    this.interceptors(instance)
    return instance(options)
  }

  isGet (options) {
    if (options.method === 'get') {
      options.url = `${options.url}?${qs.stringify(options.data)}`
      delete options.data
    }
    return options
  }
}

const http = new Http(HTTP_CONFIG)
export default http
